var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1302_37489",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1302_37489",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEwklEQVR4nO2cT4gcRRTGS6MGMSoiIptsggoqePCiBz158SLE6MEccvEk/kui3nJQ+L7q6dmdZdlDX8QhIhhQsF2SQ4h/EHLysip48GC8CGIOCq66iZJIdo08t4RxmN3pnu7q6ul+PyhYFnbr1fteVb+uV9XGKIqiKIqiKIqiKIqiKMoAnU5nL4BlABdIXtXGLX0gPgJwMoqi+0tzPslVdTrzBt4qgNnCAkjkq/M50awHkJYhgC47nHjZXSssgEY/Cz3zVACGTRpUAKoArU5bTcXPgBdMwwHwYl0FWAFwg2k4SZLsBPBF3QRYieN4xrSEOI5nsopQuLMsy04bIn8YGbOMPbgApkIA7CN5FMAnAM4B+MO1c+53R2TrpEqbWiFAHMd7SPYBrGeYkRuyBQDgripsa7wAAJ4meXHCXckDvu1rtAAkX5WIzuv8odnwimcbmykANiO/iPMHRfA2ExopAIDZSZadMcvRbh+2NlWAd8py/kA77sPWxgkAYF/GbCfvLFgvpUI1jQIM1pTH1UxJHvUQ/f+1w0Xt8+Efrx1sU1NeHRWRJD/2KMCZovaV7R/ju4PtasoYUTMl+Z0vAeSNuah9ZfunCgEu5KmZwmMNWv53UfvK9k9QAQD8XmcBRtlXtn+M7w5IntpmgMuhl6C89pXtH+O7A8kmAPw64m9Xoyi6N/RDOK99ZfvHVNGBS/NSWVNd+2CrDAPAEY8z4OWi9vnwT9gORjuj9Bcxklda+yKWFwBve4j+t3zY2kgB4jjeU3I2tOarZt1IAQRr7RMlLUUb1tonjScaK4AgxZSiBRnZWzIeabQAghRTJlyO1gDsN55pvABCt9u9g2QimUyWqAdwoqpzSq0QYKhSdhjARyS/dVWzi+7nM5Ln+0g1ay2AnJVs48GsZPOI4thzooU7yrLeyjG9Nh1NBLAbwFdZfFO4s6wPPRGhDTMhSZKdJL/M6pfCHebMPPR4OsMKoI0qwNU6BYLOAKoAwaOQ0zwD9KI2J3Z+lppyFgFOho4iTmnLUlMei9RM9WMdnESATDXlrLNgdqBmGjyyWO8mu7DLpTlfURRFURRFURRlGAD3AHjWfUrgfMUvPRuuNJhYaw8CuMW3QgAeGbP9sD4/P39baEGed2/Ov1UsyBURBEAPwONSPix7fCRfH2PDiqkLaZruiKLoIZLHSH5G8lLFgvzp+j0mdgC4tuiYAJwdMwPmTF1ZWlq6USJTjHRf2FqvUhAAv5D8kORLAO7LezjMWvvUuCCS8Zlpodfr3SpHD92pt28A/F3xDPmR5LvyDNvmwsguAG8CuJzh/12SIDPTSrfbvZPkIbkfAOD7isX49w6Zc/Yzc3Nzty8sLNxM8uscf3/WNIlOp3M3gOcAvA/gpwAZVq4+AbxhmgwGMqwtLtYFbdbaR01bSP+fYZ0OXbuW/vv9/vWmrQC4bijl/atiEU6H9kGtWFxcvMmlvD33trzheQa8FnrMtaa7mccflJQ368nmnAI8GHqMU0UcxzNOkD7JHwoK8LMx5prQY5pqADwgt/TlHFTeDMvXHeTWkqbpDgAPuwf6p25PaSvnn/f1QUDFIRdPrLWPkbQAPnefS5ZZ8l7Vn0pWFEVRFEVRFEVRFEVRzNTyD5iqofolz9JtAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShared);
export default __webpack_public_path__ + "static/media/shared.cbb36824cead5f5372293af0fe909587.svg";
export { ForwardRef as ReactComponent };